import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.my.programs');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-my-programs',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.my.programs/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #fafafa;
}`],
})
export class PageMyProgramsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public rows: any[] = [];

    public statusMap: any = {
        submitted: { label: '접수완료', cls: 'bg-zinc-100 text-zinc-700' },
        screening: { label: '심사중', cls: 'bg-blue-50 text-blue-700' },
        doc_passed: { label: '서류 통과', cls: 'bg-blue-50 text-blue-700' },
        doc_failed: { label: '서류 탈락', cls: 'bg-red-50 text-red-700' },
        pt_passed: { label: '발표 통과', cls: 'bg-emerald-50 text-emerald-700' },
        pt_failed: { label: '발표 탈락', cls: 'bg-red-50 text-red-700' },
        selected: { label: '선정', cls: 'bg-emerald-100 text-emerald-800 font-semibold' },
        rejected: { label: '미선정', cls: 'bg-red-50 text-red-700' },
        withdrawn: { label: '철회', cls: 'bg-zinc-100 text-zinc-600' },
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('list_my', {});
        if (r.code == 200) this.rows = r.data.rows || [];
        this.loaded = true;
        await this.service.render();
    }

    public statusInfo(s: string) { return this.statusMap[s] || { label: s, cls: 'bg-zinc-100' }; }

    public open(r: any) {
        this.service.href(`/my/program/${r.id}`);
    }
}

export default PageMyProgramsComponent;